// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"549e9fb3","453":"c4bb484e","667":"5a5d07d5"}[chunkId] + ".chunk.js";
};